// -----------------------------------------------------------------------------
// スナックバー リデューサー
// -----------------------------------------------------------------------------
import {combineReducers} from 'redux';
import types from './types';

/**
 * メッセージ一覧
 *
 * @param {Array} state - 現在のメッセージ一覧
 * @param {Object} action - アクション
 * @return {Array} 更新されたメッセージ一覧
 */
const messages = (state = [], action) => {
  switch (action.type) {
    case types.ADD: return addMessage(state, action);       // 追加
    case types.DEL: return deleteMessage(state, action);    // 削除
    case types.CLR: return clearMessages(state, action);    // クリア
    default: break;
  }
  return state;
};

//
// メッセージ追加
//
function addMessage(state, action) {
  if (!action.message || !action.message.id) {
    console.warn('Invalid snackbar message', action);
    return state;
  }

  // 重複メッセージを取り除く
  let messages = deleteMessage(state, action);

  // メッセージ追加
  messages = [...messages, action.message]

      // 重要度+時刻順でソート
      .sort((l, r) => {
        if (l.severity !== r.severity) {
          return l.severity - r.severity;
        }
        return l.time - r.time;
      });

  // メッセージ一覧を返す
  return messages;
}

//
// メッセージ削除
//
function deleteMessage(state, action) {
  const messages = state.filter(
      (msg) => msg.hash !== action.message?.hash);
  return (messages.length !== state.length) ? messages : state;
}

//
// メッセージクリア - 指定した表示区分以外のメッセージを削除
//
function clearMessages(state, action) {
  const messages = state.filter((msg) => {
    return !msg.category || msg.category === action.category;
  });
  return (messages.length !== state.length) ? messages : state;
}

// -----------------------------------------------------------------------------
// エクスポート
// -----------------------------------------------------------------------------
export default combineReducers({
  messages,
});
